import { render, staticRenderFns } from "./customerProfitSummary.vue?vue&type=template&id=a3e70a2e"
import script from "./customerProfitSummary.vue?vue&type=script&lang=js"
export * from "./customerProfitSummary.vue?vue&type=script&lang=js"
import style0 from "./customerProfitSummary.vue?vue&type=style&index=0&id=a3e70a2e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports